
export class Simulator {
    fc: number = 0;
    vc: number = 0;
    tva: number = 0;
    svc: number = 0;
    formula_total: string = "";
    formula_studio: string = "";


    constructor(data?: Partial<Simulator>) {
        if (data) {
            Object.assign(this, data);
        }
    }

    static attributeToJson(item: any) {
        let obj = item.data.attributes;
        obj["id"] = item.data.id;
        return obj;
    }
}